// Translation: External > Provider button (Arabic)
export default Object.freeze({
	continueWithProvider: '',
	signUpWithProvider: '',
	signInWithProvider: ''
})
